import AppTypecategoriesIndex from "./typeCategory.vue";
import AppTypecategoriesList from "./list/list.vue";
import AppTypecategoriesItem from "./item/item.vue";

const routes = [
  {
    path: "/typeCategory",
    component: AppTypecategoriesIndex,
    meta: {
      auth: {
        roles: "typeCategory.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "typeCategory.index",
        component: AppTypecategoriesList,
        meta: {
          auth: {
            roles: "typeCategory.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "typeCategory.create",
        component: AppTypecategoriesItem,
        meta: {
          auth: {
            roles: "typeCategory.create",
            redirect: { name: "typeCategory.index" }
          }
        }
      },
      {
        path: ":id",
        name: "typeCategory.edit",
        component: AppTypecategoriesItem,
        meta: {
          auth: {
            roles: "typeCategory.update",
            redirect: { name: "typeCategory.index" }
          }
        }
      }
    ]
  }
];

export default routes;
